<template>
  <div>
    <SavedImportantData />
    <Summary />
  </div>
</template>

<script>
import SavedImportantData from './SavedImportantData.vue';
import Summary from '../../Summary/index.vue';

export default {
  components: {
    SavedImportantData,
    Summary
  },
  computed: {
    isResultSaved() {
      return this.$store.getters.isResultSaved;
    }
  },
}
</script>
